import { render, staticRenderFns } from "./StudentSummaryReport.vue?vue&type=template&id=2d875104&scoped=true&"
import script from "./StudentSummaryReport.vue?vue&type=script&lang=js&"
export * from "./StudentSummaryReport.vue?vue&type=script&lang=js&"
import style0 from "./StudentSummaryReport.vue?vue&type=style&index=0&id=2d875104&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d875104",
  null
  
)

export default component.exports